import { mode, StyleFunctionProps } from '@chakra-ui/theme-tools'

const baseStyle = (props: StyleFunctionProps) => ({
  control: {
    _checked: {
      bg: 'brand.500',
      borderColor: 'brand.500',
      _hover: {
        bg: 'brand.500',
        borderColor: 'brand.500',
      },
    },
    _focusVisible: {
      boxShadow: 'outline',
      borderColor: mode('brand.500', 'brand.200')(props),
    },
  },
})

export default {
  baseStyle,
}
